import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { downloadPPTX } from '@fortem-monorepo/js-utilities'
import { useApi } from '@fortem-monorepo/react-spa'
import { Factsheets } from '@fortem-monorepo/web-sdk'

import { toastApiError } from '@/lib/error-toast'

export const useCreateIndicativeFactsheetMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: async (
      body: Factsheets.CreateIndicativeBody & {
        structure_name: string
        strike_date: string
      },
    ) => {
      const data = await api.factsheets.createIndicative(body)
      return downloadPPTX(
        data,
        `${body.structure_name}-factsheet-${body.strike_date}-indicative.pptx`,
      )
    },
    onSuccess: (_data, _params) => {
      toast.success(`Successfully created factsheet for ${_params.isin}`)
    },
    onError: (error, _params) => {
      toastApiError(error, `Error creating factsheet for ${_params.isin}`)
    },
  })
}

export const useCreateFinalFactsheetMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: async (
      body: Factsheets.CreateFinalBody & {
        structure_name: string
        strike_date: string
      },
    ) => {
      const data = await api.factsheets.createFinal(body)
      return downloadPPTX(
        data,
        `${body.structure_name}-factsheet-${body.strike_date}-indicative.pptx`,
      )
    },
    onSuccess: (_data, _params) => {
      toast.success(`Successfully created factsheet for ${_params.isin}`)
    },
    onError: (error, _params) => {
      toastApiError(error, `Error creating factsheet for ${_params.isin}`)
    },
  })
}
